export const ailaEmptyStateImg =
	"https://memorang-prod-media.s3.amazonaws.com/aila_empty.png";
